import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import { combineReducers } from "@reduxjs/toolkit";
import authenticationReducer from "../features/authentication/authenticationSlice";
import i18nReducer from "../features/localization/localizationSlice";
import sessionsReducer from "../features/sessions/sessions-slice";
import themeReducer from "../features/theme/themeSlice";
import { injectStore } from "../features/axiosInstance/axiosInstance";
import { dateSerializableConfig } from "./middleware";

const rootReducer = combineReducers({
  authentication: authenticationReducer,
  i18n: i18nReducer,
  sessions: sessionsReducer,
  theme: themeReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: dateSerializableConfig,
    }),
});

injectStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
